module.exports = {
  THEME: 'light',
  COMPONENTS: {
    REGISTER: true,
  },
  PAGINATION_CONTINUOUS: true,
};
